"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadImageFromURL = exports.loadFabricImageFromURL = void 0;
var fabric_1 = require("fabric");
function loadFabricImageFromURL(src) {
    return new Promise(function (resolve) {
        fabric_1.fabric.Image.fromURL(src, function (img) {
            resolve(img);
        });
    });
}
exports.loadFabricImageFromURL = loadFabricImageFromURL;
function loadImageFromURL(src) {
    return new Promise(function (resolve) {
        var image = new Image();
        image.src = src;
        image.crossOrigin = "Anonymous";
        image.onload = function () {
            resolve(image);
        };
    });
}
exports.loadImageFromURL = loadImageFromURL;
//# sourceMappingURL=image-loader.js.map